import { v4 as uuidv4 } from 'uuid';

export const updateUserSession = (userSessionApiPath) => {
  const options = {
    url: `${userSessionApiPath}/UpdateUserSession.v1`,
    init: {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'one-data-correlation-id': uuidv4(),
      },
      body: JSON.stringify({}),
      credentials: 'include',
    },
  };
  return fetch(options.url, options.init);
};
